(() => {
  const roots = document.querySelectorAll('[data-article-mystery-drop]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const launcher = root.querySelector('[data-mystery-launcher]');
    const sheet = root.querySelector('.article-mystery-drop__sheet');
    const closeButtons = root.querySelectorAll('[data-mystery-close]');
    const canvas = root.querySelector('[data-mystery-canvas]');
    const fallback = root.querySelector('[data-mystery-fallback]');
    const tapButton = root.querySelector('[data-mystery-tap]');
    const title = root.querySelector('[data-mystery-title]');
    const copy = root.querySelector('[data-mystery-copy]');
    const kicker = root.querySelector('[data-mystery-kicker]');
    const reward = root.querySelector('[data-mystery-reward]');
    const actions = root.querySelector('[data-mystery-actions]');
    const burst = root.querySelector('[data-mystery-burst]');
    const steps = [...root.querySelectorAll('[data-mystery-step]')];
    const shipStart = root.querySelector('[data-mystery-ship-start]');
    const shipEnd = root.querySelector('[data-mystery-ship-end]');
    const discoverLink = root.querySelector('[data-mystery-discover]');

    const articleId = root.dataset.articleId || 'unknown';
    const articleHandle = root.dataset.articleHandle || '';
    const articleTitle = root.dataset.articleTitle || document.title;
    const productId = root.dataset.productId || '';
    const productHandle = root.dataset.productHandle || '';
    const productTitle = root.dataset.productTitle || '';
    const productImage = root.dataset.productImage || '';
    const productImages = (() => {
      try {
        const images = JSON.parse(root.dataset.productImages || '[]');
        return [...new Set(images.filter(Boolean))].slice(0, 4);
      } catch (error) {
        return [];
      }
    })();
    const productUrl = root.dataset.productUrl || '';
    const discountCode = root.dataset.discountCode || 'WELCOME10';
    const discoverUrl = root.dataset.discoverUrl || '/collections/new-arrivals';
    const delayMs = Math.max(0, Number(root.dataset.delaySeconds || 6) * 1000);
    const autoOpen = root.dataset.autoOpen !== 'false';
    const accentColor = root.dataset.accentColor || '#ef272d';
    const storageKey = `wahup_mystery_drop_${articleId}`;
    const mobileChatQuery = window.matchMedia('(max-width: 749px)');
    const chatSelectors = [
      '#ShopifyChat',
      '[id^="ShopifyChat"]',
      '[id*="shopify-chat"]',
      '[class*="shopify-chat"]',
      '[class*="ShopifyChat"]',
      'inbox-online-store-chat',
      'iframe[src*="shopifychat"]',
      'iframe[src*="shopify.com/inbox"]',
      'iframe[src*="inbox.shopify"]',
      'iframe[title*="chat" i]',
      'iframe[aria-label*="chat" i]',
      '[aria-label*="chat" i][role="button"]',
      '[data-testid*="chat" i]'
    ];
    let tapCount = 0;
    let isOpen = false;
    let previousFocus = null;
    let renderer = null;
    let scene = null;
    let camera = null;
    let box = null;
    let rafId = 0;
    let resizeObserver = null;
    let threeStarted = false;

    root.style.setProperty('--mystery-accent', accentColor);
    root.style.setProperty('--mystery-pink', accentColor);
    if (discoverLink) discoverLink.href = discoverUrl;

    const hideMobileChat = () => {
      if (!mobileChatQuery.matches) return;
      chatSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          element.hidden = true;
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('opacity', '0', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
        });
      });
    };

    const formatDate = (date) => date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });

    const setShippingDates = () => {
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + 3);
      end.setDate(end.getDate() + 7);
      if (shipStart) shipStart.textContent = formatDate(start);
      if (shipEnd) shipEnd.textContent = formatDate(end);
    };

    const getSessionId = () => {
      const sessionKey = `wahup_mystery_session_${articleId}`;
      try {
        let sessionId = sessionStorage.getItem(sessionKey);
        if (!sessionId) {
          sessionId = typeof crypto.randomUUID === 'function'
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
          sessionStorage.setItem(sessionKey, sessionId);
        }
        return sessionId;
      } catch (error) {
        return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      }
    };

    const sessionId = getSessionId();

    const track = (event, details = {}) => {
      const parameters = {
        article_id: String(articleId),
        article_handle: articleHandle,
        article_title: articleTitle,
        product_id: String(productId),
        product_handle: productHandle,
        product_title: productTitle,
        product_url: productUrl,
        offer_type: 'mystery_tee_drop',
        offer_session_id: sessionId,
        discount_code: discountCode,
        ...details
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `mystery_tee_drop_${event}`,
        ...parameters
      });
      if (typeof window.gtag === 'function') {
        window.gtag('event', `mystery_tee_drop_${event}`, parameters);
      }
    };

    const hasSavedReward = () => {
      try {
        return localStorage.getItem(storageKey) === 'revealed';
      } catch (error) {
        return false;
      }
    };

    const saveReward = () => {
      try {
        localStorage.setItem(storageKey, 'revealed');
      } catch (error) {
        // The reward can still be displayed without storage.
      }
    };

    const syncProgress = () => {
      steps.forEach((step, index) => {
        step.classList.toggle('is-active', index < tapCount);
      });
    };

    const createBurst = () => {
      if (!burst) return;
      burst.replaceChildren();
      const colors = ['#e9007f', '#ef272d', '#397d62', '#f7c948', '#0ea5e9', '#111827'];
      for (let index = 0; index < 24; index += 1) {
        const piece = document.createElement('i');
        piece.style.setProperty('--piece-rotate', `${index * 15}deg`);
        piece.style.setProperty('--piece-distance', `${90 + Math.random() * 120}px`);
        piece.style.setProperty('--piece-color', colors[index % colors.length]);
        burst.append(piece);
      }
    };

    const stopThree = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = null;
      if (renderer) {
        renderer.dispose();
        renderer.forceContextLoss?.();
      }
      renderer = null;
      scene = null;
      camera = null;
      box = null;
      threeStarted = false;
      root.classList.remove('is-three-ready');
    };

    const resizeThree = () => {
      if (!renderer || !camera || !canvas) return;
      const rect = canvas.getBoundingClientRect();
      const width = Math.max(1, Math.floor(rect.width));
      const height = Math.max(1, Math.floor(rect.height));
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
    };

    const startThree = async () => {
      if (threeStarted || !canvas) return;
      threeStarted = true;

      try {
        const three = await import('https://cdn.jsdelivr.net/npm/three@0.160.1/build/three.module.js');
        const THREE = three;
        renderer = new THREE.WebGLRenderer({
          canvas,
          antialias: true,
          alpha: true
        });
        renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
        scene = new THREE.Scene();
        camera = new THREE.PerspectiveCamera(42, 1, 0.1, 100);
        camera.position.set(0, 0.5, 5.2);

        const ambient = new THREE.AmbientLight(0xffffff, 1.35);
        const key = new THREE.DirectionalLight(0xffffff, 2.2);
        key.position.set(3, 4, 5);
        scene.add(ambient, key);

        const group = new THREE.Group();
        const geometry = new THREE.BoxGeometry(2, 1.55, 2);
        const baseMaterial = new THREE.MeshStandardMaterial({
          color: accentColor,
          roughness: 0.42,
          metalness: 0.08
        });
        const boxMaterials = Array.from({ length: 6 }, () => baseMaterial.clone());
        const sideMaterialIndexes = [0, 1, 4, 5];
        const textureImages = productImages.length ? productImages : [productImage].filter(Boolean);

        await Promise.all(textureImages.slice(0, 4).map(async (imageUrl, index) => {
          try {
            const texture = await new THREE.TextureLoader().loadAsync(imageUrl);
            texture.colorSpace = THREE.SRGBColorSpace;
            texture.wrapS = THREE.ClampToEdgeWrapping;
            texture.wrapT = THREE.ClampToEdgeWrapping;
            texture.center.set(0.5, 0.5);
            const materialIndex = sideMaterialIndexes[index];
            boxMaterials[materialIndex] = new THREE.MeshStandardMaterial({
              map: texture,
              color: 0xffffff,
              roughness: 0.48,
              metalness: 0.04
            });
          } catch (error) {
            console.error('Mystery Tee Drop could not load box face image.', error);
          }
        }));

        box = new THREE.Mesh(geometry, boxMaterials);
        group.add(box);

        const lid = new THREE.Mesh(
          new THREE.BoxGeometry(2.15, 0.24, 2.15),
          new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.5 })
        );
        lid.position.y = 0.9;
        group.add(lid);

        if (productImage) {
          const texture = await new THREE.TextureLoader().loadAsync(productImage);
          texture.colorSpace = THREE.SRGBColorSpace;
          const card = new THREE.Mesh(
            new THREE.PlaneGeometry(1.22, 1.22),
            new THREE.MeshBasicMaterial({ map: texture, transparent: true })
          );
          card.position.set(0, 0.05, 1.02);
          group.add(card);
        }

        scene.add(group);
        resizeThree();
        root.classList.add('is-three-ready');
        fallback?.setAttribute('hidden', '');

        resizeObserver = new ResizeObserver(resizeThree);
        resizeObserver.observe(canvas);

        const animate = () => {
          if (!renderer || !scene || !camera) return;
          group.rotation.y += root.classList.contains('is-revealed') ? 0.018 : 0.011;
          group.rotation.x = -0.16 + Math.sin(Date.now() / 540) * 0.045;
          if (root.classList.contains('is-cracking')) {
            group.rotation.z = Math.sin(Date.now() / 42) * 0.035;
          } else {
            group.rotation.z *= 0.88;
          }
          if (root.classList.contains('is-revealed')) {
            lid.position.y = Math.min(1.72, lid.position.y + 0.035);
            lid.rotation.z = Math.min(0.68, lid.rotation.z + 0.018);
          }
          renderer.render(scene, camera);
          rafId = requestAnimationFrame(animate);
        };

        animate();
      } catch (error) {
        threeStarted = false;
        if (canvas) canvas.hidden = true;
        fallback?.removeAttribute('hidden');
        console.error('Mystery Tee Drop could not load Three.js.', error);
      }
    };

    const revealReward = () => {
      tapCount = 3;
      syncProgress();
      root.classList.remove('is-cracking');
      root.classList.add('is-revealed');
      tapButton.hidden = true;
      reward.hidden = false;
      actions.hidden = false;
      kicker.textContent = 'Unlocked';
      title.textContent = 'You got 10% off';
      copy.textContent = `${discountCode} is ready for your first order.`;
      createBurst();
      saveReward();
      track('reward_reveal');
    };

    const handleTap = () => {
      if (root.classList.contains('is-revealed')) return;
      tapCount = Math.min(3, tapCount + 1);
      syncProgress();
      root.classList.add('is-cracking');
      window.setTimeout(() => root.classList.remove('is-cracking'), 180);
      track('tap', { tap_count: tapCount });

      if (tapCount >= 3) {
        revealReward();
      } else if (tapCount === 1) {
        copy.textContent = 'Good. Two more taps to crack it open.';
      } else {
        copy.textContent = 'One more tap. Your reward is inside.';
      }
    };

    const openGame = (source = 'launcher') => {
      if (isOpen) return;
      isOpen = true;
      previousFocus = document.activeElement;
      root.hidden = false;
      root.classList.add('is-open');
      launcher.setAttribute('aria-expanded', 'true');
      sheet.setAttribute('aria-hidden', 'false');
      sheet.focus({ preventScroll: true });
      startThree();
      track('open', { open_source: source });
      if (hasSavedReward() && !root.classList.contains('is-revealed')) revealReward();
    };

    const closeGame = () => {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      launcher.setAttribute('aria-expanded', 'false');
      sheet.setAttribute('aria-hidden', 'true');
      previousFocus?.focus?.({ preventScroll: true });
      track('close');
    };

    const showLauncher = () => {
      root.hidden = false;
      root.classList.add('is-ready');
      track('launcher_view');
      if (autoOpen) {
        window.setTimeout(() => openGame('automatic'), 80);
        return;
      }
      window.setTimeout(() => {
        root.classList.add('is-attention');
        window.setTimeout(() => root.classList.remove('is-attention'), 2600);
      }, 600);
    };

    setShippingDates();
    syncProgress();
    hideMobileChat();
    new MutationObserver(hideMobileChat).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'hidden', 'src', 'title', 'aria-label']
    });
    window.addEventListener('load', hideMobileChat);
    mobileChatQuery.addEventListener('change', hideMobileChat);
    window.setTimeout(showLauncher, delayMs);
    launcher.addEventListener('click', () => openGame('launcher'));
    tapButton.addEventListener('click', handleTap);
    closeButtons.forEach((button) => button.addEventListener('click', closeGame));
    discoverLink?.addEventListener('click', () => track('discover_click'));
    root.querySelector('[data-mystery-product]')?.addEventListener('click', () => track('product_click'));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeGame();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !isOpen) stopThree();
    });
  });
})();
